import { ExperimentNames } from 'common/experiments/ExperimentDefinitions';
import { getMealPlanMerchandisingRegionId } from 'common/meal-plan/MerchandisingRegion';
import { useExperiment } from './useExperiment';

/**
 * Mirrors REGION_PRICING_CURVE_EXPERIMENTS in shef-api so the cart preview can
 * detect curve-treatment users without an extra query. Keep in sync when a new
 * region is added to the curve experiment.
 */
export const REGION_PRICING_CURVE_EXPERIMENTS: Record<number, ExperimentNames> = {
  1: ExperimentNames.PRICING_CURVE_BAY_LA_V2,
  2: ExperimentNames.PRICING_CURVE_NY_V2,
  5: ExperimentNames.PRICING_CURVE_CHI_V2,
  6: ExperimentNames.PRICING_CURVE_SEA_V2,
  7: ExperimentNames.PRICING_CURVE_BOS_V2,
  8: ExperimentNames.PRICING_CURVE_BAY_LA_V2,
  9: ExperimentNames.PRICING_CURVE_DC_V2,
  10: ExperimentNames.PRICING_CURVE_AUS_V2,
};

/**
 * Variable-service-fee treatment combines two paths:
 *   1. Stand-alone VARIABLE_SERVICE_FEE experiment + feature flag.
 *   2. Pricing-curve experiment treatment for the user's region.
 * Pass regionId to enable the second path; omit it to keep legacy behavior.
 */
export const useMealPlanVariableServiceFeeExperiment = (regionId?: number | null) => {
  const { isTreatment: isVarFeeTreatment } = useExperiment(ExperimentNames.VARIABLE_SERVICE_FEE);

  // Hook order requires a stable experiment name on every render. Falling back
  // to NY when the user has no curve experiment is fine: exposure isn't logged
  // and we ignore the result unless the region maps to that exact experiment.
  const curveExperiment =
    (regionId != null && REGION_PRICING_CURVE_EXPERIMENTS[getMealPlanMerchandisingRegionId(regionId)]) || null;
  const { isTreatment: isCurveVariantTreatment } = useExperiment(
    curveExperiment ?? ExperimentNames.PRICING_CURVE_NY_V2
  );
  const isCurveTreatment = curveExperiment != null && isCurveVariantTreatment;

  return { isTreatment: isVarFeeTreatment || isCurveTreatment };
};
